import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { CreatorEarningsCalculatorPage } from '../../../pages/tools/creator-tools/CreatorEarningsCalculatorPage';

export const Route = createFileRoute('/_site/tools/creator-earnings-calculator')({
  head: () => toolHead('creator-earnings-calculator'),
  component: CreatorEarningsCalculatorPage,
});
